<template>
  <div id="login-page">
    <a-divider><h2>Login</h2></a-divider>
    <a-form
    id="login-form"
    :form="form"
    class="login-form"
    @submit="handleSubmit"
  >
    <a-form-item>
      <a-alert v-if="userErrorMessages" type="error"  banner>
        <span slot="message" v-html="userErrorMessages"></span>
      </a-alert>
      <a-alert v-if="userSuccessSuccess" type="success"  banner>
        <span slot="message" v-html="userSuccessSuccess"></span>
      </a-alert>
      <a-alert
        v-if="successFulLogin"
        type="success"
        message="Login successful! Re-directing to your Dashboard."
        banner/>
      <br />
      <a-input
        v-decorator="[
          'username',
          { rules: [{ required: true, message: 'Please input your username!' }] }
        ]"
        placeholder="Username"
      >
        <a-icon
          slot="prefix"
          type="user"
          style="color: rgba(0,0,0,.25)"
        />
      </a-input>
    </a-form-item>
    <a-form-item v-if="! forgotPasswordFlag">
      <a-input
        v-decorator="[
          'password',
          { rules: [{ required: true, message: 'Please input your Password!' }] }
        ]"
        type="password"
        placeholder="Password"
      >
        <a-icon
          slot="prefix"
          type="lock"
          style="color: rgba(0,0,0,.25)"
        />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a
        class="login-form-forgot"
        @click="forgotPasswordFlag ^= true"
        v-html="! forgotPasswordFlag ? 'Forgot password' : 'Log in'"
      >
        Forgot password
      </a>
      <a-button
        type="primary"
        html-type="submit"
        class="login-form-button"
        v-html="forgotPasswordFlag ? 'Send password reset link' : 'Log in'"
      >
      </a-button>
      Or <router-link to="/register" >
        register now!
      </router-link>
    </a-form-item>
  </a-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'login',
  data() {
    return {
      errorMessage: false,
      successFulLogin: false,
      forgotPasswordFlag: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters('common', {
      userErrorMessages: 'commonErrors',
      userSuccessSuccess: 'commonSuccess',
    }),
  },
  methods: {
    ...mapActions('user', {
      login: 'loginUser',
      resetPassword: 'resetPassword',
    }),
    ...mapGetters('user', {
      userRole: 'getUserRole',
    }),
    handleSubmit(e) {
      e.preventDefault();
      if (!this.forgotPasswordFlag) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.login(values);
          }
        });
      } else {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.resetPassword(values);
          }
        });
      }
    },
    getRedirectPath(role, activated) {
      if (activated === 'no') {
        return { path: '/dashboard/my-profile' };
      }
      if (role === 'telas_telas_administrator') {
        /* eslint-disable no-unused-vars */
        return { path: '/dashboard/telas-user' };
      }
      if (role === 'telas_course_submitters') {
        return { path: '/dashboard' };
      }
      if (role === 'telas_interim_reviewers' || role === 'telas_admin_reviewers' || role === 'telas_certified_reviewers') {
        return { path: '/dashboard' };
      }
      return { path: '/dashboard' };
    },
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      // eslint-disable-next-line max-len
      const redirectPath = this.getRedirectPath(state.user.userDetails.user_role, state.user.userDetails.activated_by_admin);
      switch (mutation.type) {
        case 'user/LOGERROR':
          this.errorMessage = this.userErrorMessages;
          break;
        case 'user/LOGGEDIN':
          this.successFulLogin = true;
          this.errorMessage = false;
          setTimeout(() => {
            this.$router.push(redirectPath).catch((err) => {});
          }, 1000);
          break;
        default:
          // this.successFulLogin = false;
          // break;
      }
    });
  },
};

</script>
<style lang="css" scoped>
.login-form {
  max-width: 300px;
}
.login-form-forgot {
  float: right;
}
.login-form-button {
  width: 100%;
}
form#login-form {
  margin: auto;
}
</style>
